import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/components/Home";
// import Login from "@/components/Login";
// import TipoCertidao from "@/components/TipoCertidao";
// import ModeloJustificativa from "@/components/ModeloJustificativa";
// import Relatorio from "@/components/Relatorio";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    props: true,
    meta: {
      noCache: true // Adicione esta meta para indicar não-cache
    }
  },
  {
    path: "/processual/:id?",
    component: Home,
    props: true,
    meta: {
      noCache: true // Adicione esta meta para indicar não-cache
    }
  },
  {
    path: "/jurisprudencia/todas-bases",
    component: Home,
    props: true,
    meta: {
      noCache: true // Adicione esta meta para indicar não-cache
    }
  },
  {
    path: "/jurisprudencia/inteiro-teor",
    component: Home,
    props: true,
    meta: {
      noCache: true // Adicione esta meta para indicar não-cache
    }
  },
  {
    path: "/jurisprudencia/selecionada",
    component: Home,
    props: true,
    meta: {
      noCache: true // Adicione esta meta para indicar não-cache
    }
  },
  {
    path: "/jurisprudencia/boletim",
    component: Home,
    props: true,
    meta: {
      noCache: true // Adicione esta meta para indicar não-cache
    }
  }
];

export default new VueRouter({
  routes
});
